// extracted by mini-css-extract-plugin
module.exports =  {"loading":"xWyO2IHDnJ1npgmcH5mQ"};